import React from 'react';
import Navbar from '../components/Navbar';
import CadenceHero from '../components/cadence/CadenceHero';
import CadenceProblem from '../components/cadence/CadenceProblem';
import CadenceFeatures from '../components/cadence/CadenceFeatures';
import CadenceAudience from '../components/cadence/CadenceAudience';
import CadenceImpact from '../components/cadence/CadenceImpact';
import CadenceCTA from '../components/cadence/CadenceCTA';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const CadencePage = () => {
  return (
    <div className="min-h-screen bg-gray-950 text-white">
      <SEO 
        title="Traain Cadence | AI Role-Play & Performance Practice"
        description="AI-powered role-play that turns practice into performance. Real conversations, real scoring, real performance lift. Build confident, consistent performers."
        keywords="AI role-play, performance practice, sales training, customer service practice, Navigator AI, conversation practice, team training"
      />
      
      {/* Animated Background */}
      <div className="fixed inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-950 via-gray-900 to-indigo-950 animate-gradient" />
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-0 left-0 w-96 h-96 bg-cyan-500 rounded-full filter blur-3xl animate-blob" />
          <div className="absolute top-0 right-0 w-96 h-96 bg-blue-500 rounded-full filter blur-3xl animate-blob animation-delay-2000" />
          <div className="absolute bottom-0 left-1/2 w-96 h-96 bg-indigo-500 rounded-full filter blur-3xl animate-blob animation-delay-4000" />
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10">
        <Navbar />
        <CadenceHero />
        <CadenceProblem />
        <CadenceFeatures />
        <CadenceAudience />
        <CadenceImpact />
        <CadenceCTA />
        <Footer />
      </div>
    </div>
  );
};

export default CadencePage;
